import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const Zonasi = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [zonasi, setZonasi] = useState('')

    useEffect(() => {
        const getZonasi = async () => {
            const response = await masterService.getZonasiByKode(id)
            setZonasi(response.data.uraianZonasi)
        }
        getZonasi()
    }, [masterService, id])

    return (
        <>
            {zonasi}
        </>
    )
}

export default Zonasi